import { Benefit } from "../data";

/**
 * Ascending by `orderPriority`, then alphabetically by name. Benefits without
 * a priority sort after those that have one.
 *
 * Note: the CMS-era `sortCMSBenefits` had the un-prioritized comparison
 * inverted, so benefits *without* a priority sorted first — which pushed the
 * deliberately-prioritized entries (Healthcare Support, Virtual Care) to the
 * bottom of their tab. This orders them as the data intends.
 */
export const selectorSortedBenefits = (benefits: Benefit[]): Benefit[] =>
  [...benefits].sort((a, b) => {
    if (a.orderPriority !== undefined && b.orderPriority !== undefined) {
      if (a.orderPriority !== b.orderPriority) {
        return a.orderPriority - b.orderPriority;
      }
    } else if (a.orderPriority !== undefined) {
      return -1;
    } else if (b.orderPriority !== undefined) {
      return 1;
    }

    return a.name.localeCompare(b.name);
  });
